<ul class="module__list">
{% for item in module.list %}
  <li class="module__item">{{item}}</li>
{% endfor %}
</ul>
